import { render, staticRenderFns } from "./VerifiedClientList.vue?vue&type=template&id=9b26050a&"
import script from "./VerifiedClientList.vue?vue&type=script&lang=ts&"
export * from "./VerifiedClientList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports